import styled from "styled-components";

export const BaseDiv = styled.div`
    width: 80%;
    margin: 5% 12%;
    max-width: '100%';
    justify-content: center;
    display: flex;

    .SwiperName {
        @media only screen and (max-width: 800px) {
            max-width: 50%;
            width: 50%;
        }
    }

    .swiper-wrapper .wiper-slide {
        @media only screen and (max-width: 800px) {
            width: 200px;
        }
    }
`;
